// extracted by mini-css-extract-plugin
export default {"swipeable-container":"swipeable2_swipeable-container__UHxLV","swipeable-card":"swipeable2_swipeable-card__g3dJr","delete-button":"swipeable2_delete-button__fEUFh"};